import { Card, Stack, Text, Title, UnstyledButton } from "@mantine/core";
import { useHover } from "@mantine/hooks";

interface Props {
  checked?: boolean;
  error?: string;
  onClick: () => void;
  onBlur?: () => void;
  label: string;
  description: string;
}

export const CardCheckbox = ({
  checked,
  error,
  onClick,
  onBlur,
  label,
  description,
}: Props) => {
  const { hovered, ref } = useHover();

  const getStyle = () => {
    if (error) {
      return {
        borderColor: "var(--mantine-color-error-5)",
        borderWidth: "1px",
      };
    }

    if (checked) {
      return {
        borderColor: "var(--mantine-color-brand-5)",
        borderWidth: "3px",
      };
    }

    if (hovered) {
      return {
        borderColor: "var(--mantine-color-brand-5)",
        borderWidth: "1px",
      };
    }

    return {};
  };

  const getBackgroundColor = () => {
    if (error) {
      return "error.0";
    }

    if (checked) {
      return "brand.0";
    }

    return undefined;
  };

  return (
    <UnstyledButton ref={ref} onClick={onClick} onBlur={onBlur}>
      <Card
        p="s3"
        withBorder
        shadow="none"
        bg={getBackgroundColor()}
        style={getStyle()}
      >
        <Stack align="center" gap={0}>
          <Title order={6}>{label}</Title>
          <Text size="xs">{description}</Text>
        </Stack>
      </Card>
    </UnstyledButton>
  );
};
